import React, { ReactElement } from "react";

export const AplicativosInformationContent = ({
  icon,
  title,
  content,
}: {
  icon?: ReactElement;
  title: string;
  content: string;
}) => {
  return (
    <div className="row">
      <div className="col-1">{icon}</div>
      <div className="col ml-2 ml-md-0">
        <p className="aplicativos-page__title font-weight-bold text-primary">
          {title}
        </p>
        <p className="aplicativos-page__subtitle">{content}</p>
      </div>
    </div>
  );
};
